export default __webpack_public_path__ + "static/media/caps01.1993197b.gif";